import { Link } from "react-router-dom";
import { FileText, BadgePercent, CalendarCheck } from "lucide-react";
import { BOOKING_URL, BALBOA_URL } from "@/data/site";

const STEPS = [
  { icon: FileText, title: "Get an online estimate", text: "Snap photos, tell us about your space, and get a real number — no waiting for a visit." },
  { icon: BadgePercent, title: "Apply for financing", text: "PayPal Pay Later for homes. Up to $500,000 through Balboa Capital for businesses.", link: { href: BALBOA_URL, label: "Apply for commercial financing" } },
  { icon: CalendarCheck, title: "Book service online", text: "Pick your time and lock it in — all before anyone sets foot on your property." },
];

export const OnlineBand = () => (
  <section data-testid="online-band" className="bg-brand-dark text-white border-t-4 border-brand-red">
    <div className="max-w-7xl mx-auto px-4 py-14">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-2">100% Online, Start to Finish</p>
      <h2 className="text-2xl sm:text-3xl tracking-tight font-black">
        Estimate. Financing. Booking. All done online — before we ever visit your home or business.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {STEPS.map((s, i) => (
          <div key={s.title} data-testid={`online-band-step-${i}`} className="flex items-start gap-4">
            <span className="w-10 h-10 rounded-full bg-brand-ice text-brand-ink font-heading font-black flex items-center justify-center shrink-0">{i + 1}</span>
            <div>
              <p className="font-heading font-bold flex items-center gap-2"><s.icon className="w-4 h-4 text-brand-ice" /> {s.title}</p>
              <p className="text-sm text-blue-100 mt-1 leading-relaxed">{s.text}</p>
              {s.link && (
                <a href={s.link.href} target="_blank" rel="noopener noreferrer" data-testid="online-band-balboa-link"
                  className="inline-block text-sm font-bold text-brand-ice hover:text-white underline underline-offset-4 mt-1.5 transition-colors duration-200">
                  {s.link.label}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mt-8">
        <Link to="/#estimate" data-testid="online-band-estimate-btn"
          className="bg-brand-ice hover:bg-white text-brand-ink font-bold px-6 py-3 rounded-sm text-center transition-colors duration-200 text-sm">
          Start My Online Estimate
        </Link>
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-testid="online-band-book-btn"
          className="border-2 border-brand-ice/60 hover:border-white text-white font-bold px-6 py-3 rounded-sm text-center transition-colors duration-200 text-sm">
          Book Service Online
        </a>
      </div>
    </div>
  </section>
);
